export default "__VITE_ASSET__8210c1b9__"